import { useId, useRef } from 'react';
import { COMING_SOON_TEXT, COMING_SOON_TITLE } from '../../whatsapp/availability';
import { Modal } from './Modal';

/** Shown to clinics that are not on the demo list when they press "Bandeja". */
export const ComingSoonDialog = ({ onClose }: { onClose: () => void }) => {
  const ids = useId();
  const okRef = useRef<HTMLButtonElement>(null);

  return (
    <Modal
      titleId={`${ids}-t`}
      descriptionId={`${ids}-d`}
      maxWidth="max-w-[440px]"
      role="dialog"
      locked={false}
      onClose={onClose}
      initialFocus={okRef}
    >
      <img
        src="/whatsapp-proximamente.webp"
        alt="Dos gatos arman un robot azul con herramientas"
        className="block h-56 w-full rounded-xl object-cover"
      />
      <h2 id={`${ids}-t`} className="text-center text-xl font-bold text-stone-900">
        {COMING_SOON_TITLE}
      </h2>
      <p id={`${ids}-d`} className="text-center text-sm leading-[1.55] text-stone-600">
        {COMING_SOON_TEXT}
      </p>
      <div className="flex justify-center pt-1.5">
        <button
          ref={okRef}
          type="button"
          onClick={onClose}
          className="inline-flex h-11 items-center justify-center rounded-full bg-primary px-7 text-sm font-semibold text-white hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
        >
          Entendido
        </button>
      </div>
    </Modal>
  );
};
